module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAKAgMAAAAC4HKLAAAAAXNSR0IArs4c6QAAAAxQTFRFAAAAys3Syc3Syc3Rfz4KQAAAAAN0Uk5TAGbMWwOGZAAAAB5JREFUGNNjYMAPQkPx4v//GfDhQSy9ahUDXowXAABQzW+RAnGsywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/plane/product-item-separate.png
// module id = Px+t
// module chunks = 4